var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconLogout = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9 1a1 1 0 1 1 0 2H2.999L3 17h6a1 1 0 0 1 0 2H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M6.175 10.125c.063.565.55 1.005 1.144 1.005h7.845l-1.41 1.384a1.15 1.15 0 0 0 0 1.647c.407.4 1.045.452 1.514.134l.129-.103 3.132-3.068a1.566 1.566 0 0 0 0-2.245l-3.097-3.036a1.205 1.205 0 0 0-1.515-.135l-.128.103-.1.108c-.397.482-.367 1.148.064 1.57l1.411 1.385H7.32a1.14 1.14 0 0 0-1.15 1.128z"
}))));
export default SvgIconLogout;